import React, { Component } from 'react';

class Advisoryinstructor extends Component {
    render() {
        return (
            <div>
                <section class="blue-belt padding-default">
                    <div class="row">
                        <div class="col-sm-12">
                            <br />
                            <div class="row">
                                <div class="col-sm-2"></div>
                                <div class="col-sm-4">
                                    <div class="card card-style10 ">
                                        <div class="card-body text-center">
                                            <h3 class="card-line-pd">Advisory board </h3>
                                            <br />
                                            <div class="row ">
                                                <div class="col-sm-3"> </div>
                                                <a href="<?php echo $baseurl;?>advisory-board" class="btn btn-getstarted rounded"> Know more </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="card card-style12">
                                        <div class="card-body text-center">
                                            <h3 class="card-line">Know more About your Instructors</h3>
                                            <div class="row ">
                                                <div class="col-sm-3"> </div>
                                                <a href="<?php echo $baseurl;?>know-your-instructor" class="btn btn-getstarted rounded"> Know more </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default Advisoryinstructor;